<template>
    <div>
        <div class="d-flex flex-column gap-2 question-container" v-for="(question,idx) in this.template.questions"
             :key="idx">
            <div>Question {{idx+1}}</div>
            <div>{{question['question']}}</div>
            <div>

                <div class=" d-flex flex-column gap-2">
                    <p class="my-0">Answers</p>
                    <div class="d-flex justify-content-between gap-3 my-3">
                        <div class="answers-style">
                            <div class="d-flex flex-column gap-3 answers-container">
                                <div v-for="(a,index) in question['answers']"
                                     class="d-flex gap-4 align-items-center">

                                    <div class="m-c-answer-container position-relative"
                                         :style="{backgroundColor: a.bgColor}">
                                        <input type="text"
                                               class="w-100"
                                               autocomplete="off"
                                               @input="answerTextChangeHandler($event, idx, index ,'arrange')"
                                               :placeholder="a.key" v-model="a.value"/>
                                        <!--                                        <span class="delete-answer-icon"-->
                                        <!--                                              @click="deleteAnswerHandler($event, idx, index, 'arrange')">-->
                                        <!--                                        <font-awesome-icon :icon="['fas', 'times']" size="sm"/>-->
                                        <!--                                    </span>-->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        name: 'arrange-component',
        data() {
            return {}
        },
        async mounted() {
        },
        props: ['template'],
        methods: {}
    }
</script>

<style scoped>
    .q-input {
        pointer-events: none;
        background-color: transparent !important;
        border: 1px solid #39525C;
        border-radius: 4px;
        color: var(--main-color);
        padding: 10px;
        overflow-y: scroll;
        overflow-x: hidden;
        min-height: 60px;
        max-height: 60px;
    }

    .question-container {
        border-bottom: 1px solid #e65c00;
        margin-bottom: 20px;
        padding-bottom: 20px;
    }

    .question-container:last-child {
        border-bottom: none;
    }
    .m-c-answer-container {
        width: 360px;
        border: 1px solid #39525C;
        border-radius: 8px;
        padding: 8px;
        display: flex;
        color: var(--main-color);
        gap: 4px;
    }

    .m-c-answer-container > input[type=text],
    .m-c-answer-container > input[type=text]:focus,
    .m-c-answer-container > input[type=text]:focus-visible {
        border: 0;
        color: var(--main-color);
        background-color: transparent;
        outline: 0;
    }
    input{
        pointer-events: none;
    }
</style>